

























import {Component, Emit, Model, Prop, Vue} from "vue-property-decorator";
import {CustomerStore} from "@/modules/customers/store";
import debounce from "lodash/debounce";
import CustomerLabel from "@/modules/customers/List/components/Label.vue";
import {CustomerParams} from "@/modules/customers/params";
import {CommonStatus} from "@/enums/status";

@Component({
    name: "CustomerSelector",
    components: {CustomerLabel}
})
export default class extends Vue {
    @Prop({type: Boolean, default: false}) readonly autoFocus!: boolean;
    @Prop({type: Boolean, default: false}) readonly disabled!: boolean;
    @Prop({default: "default", type: String}) readonly mode!: string;
    @Prop({default: false, type: Boolean}) readonly onlyParent!: boolean;
    @Prop({default: "Chọn khách hàng", type: String}) readonly placeholder!: string;
    @Prop({default: 'default'}) readonly size!: 'default' | 'small' | 'large';


    @Model("change")
    readonly customerRowGuid!: string | string[];

    @Emit('change')
    handleChange(value: number) {
        return value;
    }

    get ids(): string[] {
        return CustomerStore.ids;
    }

    async created() {
        try {
            const params = {
                ...new CustomerParams(),
                status: CommonStatus.Active,
                onlyParent: this.onlyParent ? 1 : undefined
            };
            await CustomerStore.listCustomer(params);
            await CustomerStore.existInListCustomer(this.customerRowGuid as any);
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Đã có lỗi xảy ra");
        }
    }

    private onSearch = debounce((value: string) => {
        const params = {
            ...CustomerStore.params,
            search: value,
            status: CommonStatus.Active,
            onlyParent: this.onlyParent ? 1 : undefined
        };
        CustomerStore.listCustomer(params);
    }, 500);
}
